module.exports = __webpack_public_path__ + "static/media/track.0a3dd47c.jpg";